export default "__VITE_ASSET__CGKa7ANG__"